import React from 'react';

export const TsuAreaModal = {
  title: 'Area',
  body: (
    <div>
      <p>
        The State, Province or Prefecture of the tsunami source.
      </p>
    </div>
  ),
};
